import isBrowser from './isBrowser';
var getHostname = function () {
    if (!isBrowser()) {
        return '';
    }
    var url = new URL(window.location.href);
    return url.hostname;
};
export default getHostname;
